import {React} from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link } from 'react-router-dom';

const actionsStyles = (theme) => ({
  color: 'primary.main',
  fontSize: theme.tokens.typography.fontSize[32],
  transition: 'transform 0.18s ease, color 0.18s ease',
  '&:hover': { color: 'primary.dark', transform: 'scale(1.15)' },
});

const Actions = ({row}) => {
    return (
      <Link to={`order/${row['orderId']}/details`}>
      <OpenInNewIcon
      sx={actionsStyles}
      className="file-icons-hover"
    />
    </Link>
    )
  }
  export default Actions;
